'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./~/call-bind-apply-helpers/~/function-bind/index.js
// module id = 163
// module chunks = 1